var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[_c(_setup.ListConcedenteContatos,{attrs:{"concedente_id":_setup.concedente.id,"open-edit-in-modal":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }